import React from "react";
import { auth, db } from "../firebase";
import { doc, getDoc } from "firebase/firestore";
import { useQuery } from "@tanstack/react-query";

const useUserData = (year) => {
  const authUser = auth.currentUser;
  // const currYear = year ? year : process.env.REACT_APP_CURRENT_YEAR;
  const FetchData = async () => {
    // console.log("Fetching Data for ", ay);
    // const currentYear = currYear;
    const currentAY = "2024-2025";


    const match = authUser.email.match(/\+(.*?)@/);
    const pan = match[1].toUpperCase();

    // const docRef = doc(db, currentYear.toString(), pan);
    const docRef = doc(db, "itrWorking", pan);
    const docSnap = await getDoc(docRef);
    if (!docSnap.exists()) {
      // throw new Error("No such User Found!");
      // console.log("No such User Found!");
      return {};
    }
    if (!docSnap.data()) {
      throw new Error("User data is undefined");
    }
    return docSnap.data();
  };
  const {
    data: userData,
    isLoading,
    isError,
    error,
  } = useQuery(["UserData", authUser?.uid, year, "itrWorking"], FetchData, {
    initialData: {},
  });
  if (isLoading) {
    console.log("Loading...");
    return <div>Loading...</div>;
  }
  if (isError) {
    console.log("Error", error);
    throw new Error(error);
  }
  // console.log("Updated User", userData);
  return userData;
};

export default useUserData;
